import { BaseSidebarObject } from '@y42/gojs';
import { IBackgroundColorNode, ILockedNode, IShadowNode, IZOrderableNode } from '../../common/models/node.interfaces';

export class ShapeNode
  extends BaseSidebarObject
  implements IShadowNode, IBackgroundColorNode, ILockedNode, IZOrderableNode
{
  constructor(
    public key = '',
    public category = '',
    public geometry = '',
    public background = '',
    public borderColor = '',
    public locked = false,
    public size = '100 100',
    public location = '0 0',
    public shadowColor = '',
    public shadowOffset = '',
    public shadowBlur = 0,
    public layerName = '',
    public zOrder = NaN,
  ) {
    super();
  }
}
